import { DashboardTeamComparisonsCard } from "@/components/dashboard/dashboard-stats/all-comparison-charts/DashboardTeamComparisonsCard";
import { DashboardTeamGoalsCard } from "@/components/dashboard/dashboard-stats/main-stats/DashboardTeamGoalsCard";
import { DashboardTeamTrendsCard } from "@/components/dashboard/dashboard-stats/trend-and-funnel-charts/DashboardTeamTrendsCard";

import {
  DASHBOARD_GRID_FUNNEL_COLUMN_CLASS,
  DASHBOARD_GRID_GOALS_COLUMN_CLASS,
  DASHBOARD_GRID_STATS_COLUMN_CLASS,
} from "@/lib/constants";
import { cn } from "@/lib/utils";
import {
  DashboardComparisonMetric,
  DashboardKpiOverview,
  GoalPeriod,
} from "@/types";

// Team view: how the staffers compare, and where the team lands by period end.
export const DashboardStatRowAllView = ({
  comparisonMetric,
  goalsPeriod,
  isPending,
  itemClassName,
  onGoalsPeriodChange,
  onMetricChange,
  overview,
}: {
  comparisonMetric: DashboardComparisonMetric;
  goalsPeriod: GoalPeriod;
  isPending: boolean;
  itemClassName: string;
  onGoalsPeriodChange: (period: GoalPeriod) => void;
  onMetricChange: (metric: DashboardComparisonMetric) => void;
  overview: DashboardKpiOverview | undefined;
}) => (
  <>
    <div className={cn(itemClassName, DASHBOARD_GRID_GOALS_COLUMN_CLASS)}>
      <DashboardTeamGoalsCard
        goalsPeriod={goalsPeriod}
        isPending={isPending}
        onGoalsPeriodChange={onGoalsPeriodChange}
        onSelectComparisonMetric={onMetricChange}
        overview={overview}
        selectedComparisonMetric={comparisonMetric}
      />
    </div>
    <div className={cn(itemClassName, DASHBOARD_GRID_FUNNEL_COLUMN_CLASS)}>
      <DashboardTeamComparisonsCard
        goalsPeriod={goalsPeriod}
        isPending={isPending}
        metric={comparisonMetric}
        onMetricChange={onMetricChange}
        overview={overview}
      />
    </div>
    <div className={cn(itemClassName, DASHBOARD_GRID_STATS_COLUMN_CLASS)}>
      <DashboardTeamTrendsCard
        goalsPeriod={goalsPeriod}
        isPending={isPending}
        metric={comparisonMetric}
        onMetricChange={onMetricChange}
        overview={overview}
      />
    </div>
  </>
);
